export class ProcessActivityDTO {
    Activityid: number | undefined;
    Rolefromid: number | undefined;
    Userfrom: string | undefined;
    Actionid: number | undefined;
    Actionuser: string | undefined;
    Comment: string | undefined;
    Isfinalapproval: boolean | false;
    RequiresMoreInfo: boolean | false;
  }